import Companies from "./companies";

export default Companies;